module.exports = __webpack_public_path__ + "static/media/Beric Dondarrion.a6f41529.jpg";